module.exports = __webpack_public_path__ + "img/black-vip-logo.2c5d2ebf.png";